import { render } from "./InformeHornos.vue?vue&type=template&id=7367e405&scoped=true"
import script from "./InformeHornos.vue?vue&type=script&lang=js"
export * from "./InformeHornos.vue?vue&type=script&lang=js"

import "./InformeHornos.vue?vue&type=style&index=0&id=7367e405&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/CERAMICAS/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7367e405"]])

export default __exports__